export default __webpack_public_path__ + "static/media/add-poll.7d9453ee.svg";